import React, { Fragment } from "react";
import { Cell, Grid, Row } from "@material/react-layout-grid";
import BundleCard from "./BundleCard";
import { CircularProgress } from "@cdk-uip/react-circular-progress";
import "./style.css";

function BundleListV2({
  getBundleList,
  fetchingBundleList,
  bundleList,
  entity = {},
  accessToken,
  filteredBundleList,
  setBundleShareName,
  setBundleShareId,
  setScreen,
  setSelectedBundle
}) {

  return (
    <Fragment>
      {fetchingBundleList ? (
        <div className="loading-container">
          <h3>Loading Bundle Details...</h3>
          <CircularProgress />
        </div>
      ) : (
        <div className="bundle-list_container">
          <Grid>
            <Row></Row>
            <Row>
              {filteredBundleList.map((bundle, index) => (
                <Cell
                  desktopColumns={6}
                  phoneColumns={5}
                  tabletColumns={5}
                  key={index}
                >
                  <BundleCard
                    bundleList={bundleList}
                    apiBundle={bundle}
                    entity={entity}
                    setScreen={setScreen}
                    setBundleShareId={setBundleShareId}
                    setBundleShareName={setBundleShareName}
                    isVersion2={true}
                    setSelectedBundle={setSelectedBundle}
                  />
                </Cell>
              ))}
            </Row>
          </Grid>
        </div>
      )}
    </Fragment>
  );
}
export default BundleListV2;

